import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import { InView } from 'react-intersection-observer';
import { isMobileMedium } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import { useRef, useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import ButtonLink from '../../../components/ButtonLink';
import css from './GiftCards.module.scss';
import useEventListener from '../../../utils/hooks/useEventListener';
import windowHeight from '../../../utils/dom/windowHeight';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var GiftCards = function GiftCards(_ref) {
  var cta = _ref.cta,
      imageBackground = _ref.imageBackground,
      imageCard = _ref.imageCard,
      imageCase = _ref.imageCase,
      isInView = _ref.isInView,
      url = _ref.url,
      title = _ref.title;
  var rootRef = useRef();
  var cardRef = useRef();

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      progress = _useState2[0],
      setProgress = _useState2[1]; // between 0 and 1


  var onScroll = function onScroll() {
    if (!rootRef || !rootRef.current || !cardRef || !cardRef.current || isMobileMedium()) {
      return;
    }

    var _rootRef$current$getB = rootRef.current.getBoundingClientRect(),
        top = _rootRef$current$getB.top;

    var cardHeight = cardRef.current.offsetHeight;
    var targetTop = 0.5 * windowHeight() - 0.5 * cardHeight;
    var newProgress = top <= 0 ? 1 : Math.max(Math.min(targetTop / top, 1), 0); // clamp 0 to 1

    setProgress(newProgress);
  };

  useEventListener('scroll', onScroll, isInView ? window : null);
  var leftStyle = {
    transform: "translate3d(".concat((1 - progress) * 50, "%,0,0)")
  };
  var rightStyle = {
    transform: "translate3d(-".concat((1 - progress) * 50, "%,0,0)")
  };
  var backgroundStyle = {
    backgroundImage: "url(".concat(imageBackground, ")"),
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'top'
  };
  return /*#__PURE__*/_jsx("section", {
    className: css.root,
    ref: rootRef,
    style: backgroundStyle,
    children: /*#__PURE__*/_jsxs("div", {
      className: css.content,
      children: [/*#__PURE__*/_jsx("h2", {
        className: css.title,
        dangerouslySetInnerHTML: {
          __html: title
        }
      }), /*#__PURE__*/_jsxs("div", {
        className: css.cardWrap,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.card,
          ref: cardRef,
          style: leftStyle,
          children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, imageCase), {}, {
            wrap: false,
            sizes: [320, 600, 900, 1200]
          }))
        }), /*#__PURE__*/_jsx("div", {
          className: cc([css.card, css.inner]),
          style: rightStyle,
          children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, imageCard), {}, {
            wrap: false,
            sizes: [320, 600, 900, 1200]
          }))
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: css.links,
        children: /*#__PURE__*/_jsx(ButtonLink, {
          big: true,
          href: url,
          children: /*#__PURE__*/_jsx("span", {
            dangerouslySetInnerHTML: {
              __html: cta
            }
          })
        })
      })]
    })
  });
};

GiftCards.propTypes = {
  cta: PropTypes.string.isRequired,
  imageBackground: PropTypes.string.isRequired,
  imageCard: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  imageCase: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  isInView: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

var GiftCardsInViewWrapper = function GiftCardsInViewWrapper(props) {
  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isInView = _useState4[0],
      setIsInView = _useState4[1];

  var onChange = function onChange(newIsInView) {
    if (isInView !== newIsInView) {
      setIsInView(newIsInView);
    }
  };

  return /*#__PURE__*/_jsx(InView, {
    onChange: onChange,
    threshold: [0.1],
    children: /*#__PURE__*/_jsx(GiftCards, _objectSpread(_objectSpread({}, props), {}, {
      isInView: isInView
    }))
  });
};

GiftCardsInViewWrapper.propTypes = {
  cta: PropTypes.string.isRequired,
  imageCard: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  imageCase: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  title: PropTypes.string,
  url: PropTypes.string.isRequired
};
export default GiftCardsInViewWrapper;